var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A8A29E",
    d: "m15.3 34.282-1.5818-1.5818 8.6998-8.6998-8.6998-8.6998 1.5818-1.5818 8.6998 8.6998 8.6998-8.6998 1.5818 1.5818-8.6998 8.6998 8.6998 8.6998-1.5818 1.5818-8.6998-8.6998z",
    strokeWidth: 0.75323
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e8860f1ba6cf0ab5471bf37354f3e7b8.svg";
export { ForwardRef as ReactComponent };